import OrderDTO from "@/dto/order/OrderDTO";
import type GlobalStore from "@/store";

export type CheckDouDianRefundingOrderConfig = {
    needModal: boolean;
};

export enum ShipValidationRuleKey {
    checkDisabledPrintShipping = "checkDisabledPrintShipping",
    checkRefundingOrder = "checkRefundingOrder",
    checkJdMaxEwaybill = "checkJdMaxEwaybill",
    checkAutoPrint = "checkAutoPrint",
    checkOrderItemPartQuantityShip = "checkOrderItemPartQuantityShip",
    checkCannotShipTag = "checkCannotShipTag",
    checkManualOrderWaybillNo = "checkManualOrderWaybillNo",
    checkVirtualShip = "checkVirtualShip",
    checkDouDianRefundingOrder = "checkDouDianRefundingOrder",
}

export interface ShipValidationRule {
    [ShipValidationRuleKey.checkDisabledPrintShipping]?: boolean;
    [ShipValidationRuleKey.checkRefundingOrder]?: boolean;
    [ShipValidationRuleKey.checkJdMaxEwaybill]?: boolean;
    [ShipValidationRuleKey.checkAutoPrint]?: boolean;
    [ShipValidationRuleKey.checkOrderItemPartQuantityShip]?: boolean;
    [ShipValidationRuleKey.checkCannotShipTag]?: boolean;
    [ShipValidationRuleKey.checkManualOrderWaybillNo]?: boolean;
    [ShipValidationRuleKey.checkVirtualShip]?: boolean;
    [ShipValidationRuleKey.checkDouDianRefundingOrder]?: boolean | CheckDouDianRefundingOrderConfig;
}

export interface ShipValidationResult {
    canShip: boolean;
    canShipOrders: OrderDTO[];
    errorMessage?: string;
}

export type ShipValidator = (
    orders: OrderDTO[],
    rule: ShipValidationRule,
    globalStore: typeof GlobalStore,
) => Promise<ShipValidationResult>;
